import { atomWithReset } from "jotai/utils";

export const claimIntegrationStatusModalAtom = atomWithReset<{
  visible: boolean;
  publicId: string | null;
}>({
  visible: false,
  publicId: null
});
